export function pxToRem(value: number): string {
  return `${value / 16}rem`;
}
